import { GrupoFiltroDTO, IGrupoFiltroDTO } from "./GrupoFiltro.DTO";
import { EnvioDTO } from "./Envio.DTO";
import { PaisDTO } from "./Pais.DTO";
import { GrupoUsuariosActivosDTO, IGrupoUsuariosActivosDTO } from "./IGrupoUsuariosActivos.DTO";
import { Nilable } from "@shared/utils";
import { MapperDTO } from "@shared/interfaces/mapper";

export interface IGrupoHeadDTO {
    id: number;
    name: string;
    active: boolean;
    target_country: Nilable<string>;
}

export interface IGrupoDTO extends IGrupoHeadDTO {
    signon_triggers: IGrupoFiltroDTO[];
    marketplace_enabled: boolean;
    referral_enabled: boolean;
    active_users: Nilable<IGrupoUsuariosActivosDTO>;
}

export class GrupoHeadDTO implements MapperDTO<IGrupoHeadDTO> {
    public id = 0;
    public nombre = "";
    public activo = true;
    public targetPais = new PaisDTO();

    constructor(json: Nilable<Partial<IGrupoHeadDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IGrupoHeadDTO>): void {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.active != null) {
            this.activo = json.active;
        }
        if (json.target_country != null) {
            this.targetPais = new PaisDTO({ code: json.target_country });
        }
    }

    public obtenerJSON(): IGrupoHeadDTO {
        return {
            id: this.id,
            name: this.nombre,
            active: this.activo,
            target_country: this.targetPais?.codigo ?? null
        };
    }
}

export class GrupoDTO extends GrupoHeadDTO implements MapperDTO<IGrupoDTO> {
    public gruposFiltros: GrupoFiltroDTO[] = [];
    public marketplaceActivado = true;
    public referenteActivado = true;
    public envios: EnvioDTO[] = [];
    public usuariosActivos: GrupoUsuariosActivosDTO = new GrupoUsuariosActivosDTO();

    constructor(json: Nilable<Partial<IGrupoDTO>> = null) {
        super();
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IGrupoDTO>) {
        super.cargarDTO(json);
        if (json.signon_triggers != null) {
            this.gruposFiltros = json.signon_triggers.map(signon => new GrupoFiltroDTO(signon));
        }
        if (json.marketplace_enabled != null) {
            this.marketplaceActivado = json.marketplace_enabled;
        }
        if (json.referral_enabled != null) {
            this.referenteActivado = json.referral_enabled;
        }
        if (json.active_users != null) {
            this.usuariosActivos = new GrupoUsuariosActivosDTO(json.active_users);
        }
    }

    public obtenerJSON(): IGrupoDTO {
        return {
            ...super.obtenerJSON(),
            signon_triggers: this.gruposFiltros.map(signon => signon.obtenerJSON()),
            marketplace_enabled: this.marketplaceActivado,
            referral_enabled: this.referenteActivado,
            active_users: this.usuariosActivos.toJSON()
        };
    };

    public clon(): GrupoDTO {
        const clon = new GrupoDTO(this.obtenerJSON());
        clon.envios = this.envios.map(envio => new EnvioDTO(envio.toJSON()));
        return clon;
    }
}
